import React from 'react';
import { Box } from '@mui/material';

const MONO = "'IBM Plex Mono', monospace";

const STATES = {
  processed:   { bg: 'rgba(68,208,123,.12)',  border: 'rgba(68,208,123,.4)',  dot: '#44d07b', text: '#7fe0a6' },
  active:      { bg: 'rgba(68,208,123,.12)',  border: 'rgba(68,208,123,.4)',  dot: '#44d07b', text: '#7fe0a6' },
  paid:        { bg: 'rgba(68,208,123,.12)',  border: 'rgba(68,208,123,.35)', dot: '#44d07b', text: '#7fe0a6' },
  processing:  { bg: 'rgba(45,212,191,.1)',   border: 'rgba(45,212,191,.35)', dot: '#2dd4bf', text: '#2dd4bf' },
  uploaded:    { bg: 'rgba(120,150,200,.1)',  border: 'rgba(120,150,200,.3)', dot: '#8298bd', text: '#8298bd' },
  unconfirmed: { bg: 'rgba(120,150,200,.1)',  border: 'rgba(120,150,200,.3)', dot: '#8298bd', text: '#8298bd' },
  error:       { bg: 'rgba(244,113,106,.1)',  border: 'rgba(244,113,106,.35)',dot: '#f4716a', text: '#f4a39e' },
  inactive:    { bg: 'rgba(120,150,200,.1)',  border: 'rgba(120,150,200,.3)', dot: '#8298bd', text: '#8298bd' },
};

export default function StatusPill({ status = 'uploaded', label, pulse = false, sx = {} }) {
  const key = (status || 'uploaded').toLowerCase();
  const cfg = STATES[key] || STATES.uploaded;
  const text = label || key.toUpperCase();

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        px: '11px',
        py: '4px',
        borderRadius: '999px',
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: cfg.dot,
          flexShrink: 0,
          ...(pulse && {
            animation: 'pulseDot 2s ease-in-out infinite',
            '@keyframes pulseDot': { '0%,100%': { opacity: .35 }, '50%': { opacity: 1 } },
          }),
        }}
      />
      <Box component="span" sx={{ fontFamily: MONO, fontSize: '11px', letterSpacing: '.06em', color: cfg.text }}>
        {text}
      </Box>
    </Box>
  );
}
